<template>
  <modal
    name="add-department-modal"
    :classes="'customModal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    :width="650"
    height="auto"
    @closed="closeModal()"
  >
    <div class="modalWrapper">
      <div class="content__box">
        <div class="content__box__header">
          <p class="text-white txt--ss opacity--50">Add Department</p>
        </div>
        <div class="content__divider"></div>
        <div class="content__box__body">
          <div class="form-group">
            <label class="txt--xs txt--off-white mb-2"
              >Department Name(s) separate by commas or pressing enter</label
            >
           <!--  <multiselect
              class="multi-select-input"
              v-model="value"
              :options="options"
              :multiple="false"
              :close-on-select="true"
              group-values="permits"
              group-label="poperty"
              :group-select="true"
              placeholder="add Department"
              label="name"
            >
              <span slot="noResult">Oops! No permit found</span>
              <template slot="tag"
                ><span class="multiselect__tag">
                  <span></span>
                  <i
                    aria-hidden="true"
                    tabindex="1"
                    class="multiselect__tag-icon"
                  ></i> </span
              ></template>
            </multiselect> -->

             <vue-tags-input
                v-model="department_tag"
                :tags="department_tags"
                @tags-changed="(newTags) => (department_tags = newTags)"
                :separators="[',']"
                placeholder="Enter department name(s)"
              />
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center flex-wrap mt-4">
        
        <ButtonWithSpinner
            class="button button--primary button--sm mr-3"
            @click="createDepartments()"
            :disabled="button.disabled"
            :loading="button.loading"
            :success="button.success"
        >
          Add</ButtonWithSpinner
        >
        <button
          type="button"
          class="button button--outline button--sm"
          @click="closeModal()"
        >
          Cancel
        </button>
      </div>
      <div class="session__modal__close" @click="closeModal()">
        <i class="fas fa-times"></i>
      </div>
    </div>
  </modal>
</template>
<script>
import "vue-search-select/dist/VueSearchSelect.css";
//import { ModelSelect, ModelListSelect } from "vue-search-select";
import ButtonWithSpinner from "@/components/Button";
import VueTagsInput from "@johmun/vue-tags-input";
//import Toggle from "@/components/toggle";
export default {
  name: "AddDepartment",
  components: {
    // AppToggle: Toggle,
    // ModelListSelect,
    // ModelSelect,
    VueTagsInput,
    ButtonWithSpinner,
  },
  data() {
    return {
      //value: null,
      //options: ["list", "of", "options"],
      //unlimited_validaiton: true,
      department_names: "",
      department_tag: "",
      department_tags: [],
      button: {
        loading: false,
        success: false,
        disabled: false,
      },
    };
  },
  computed: {
    filteredItems() {
      return this.autocompleteItems.filter((i) => {
        return i.text.toLowerCase().indexOf(this.department_tag.toLowerCase()) !== -1;
      });
    },
  },
  created() {},
  methods: {
    closeModal() {
      this.resetData();
      this.$modal.hide("add-department-modal");
    },
    resetData(){
      this.department_names = "";
      this.department_tag = "";
      this.department_tags = [];
      this.button = {
        loading: false,
        success: false,
        disabled: false,
      };
    },
    createDepartments(){

      setTimeout(()=>{
        this.department_names = this.department_tags
          .filter((val) => val.text)
          .map(({ text }) => text);

        if (this.department_names == "") {
          this.$toasted.show("Please add department names!", {
            icon: "times-circle",
            className: "error-class",
          });
          return;
        }
        this.formData = new FormData();

        this.formData.append("department_names", this.department_names);

        this.button.disabled = true;
        this.button.loading = true;

        this.axios
          .post(window.hostname + "api/auth/departments/save", this.formData)
          .then((res) => {
            if (res.data.status) {
              this.button.disabled = false;
              this.button.loading = false;
              this.button.success = true;
              this.$toasted.show(res.data.message, {
                icon: "check-circle",
                className: "success-class",
              });
              this.$emit("update_department", true);
              this.resetData();
              this.closeModal();
            } else {
              this.button.disabled = false;
              this.button.loading = false;
              this.$toasted.show(res.data.message, {
                icon: "times-circle",
                className: "error-class",
              });
            }
          })
          .catch((err) => {
            this.button.disabled = false;
            this.button.loading = false;
            this.button.success = false;
            this.$toasted.show(err.response.data.message, {
              icon: "times-circle",
              className: "error-class",
            });
          });
      },500)
     
        



    }


    },  
  };

</script>

<style scoped>
.modified-toggle-switch p {
  flex-basis: 50%;
}

.modified-toggle-switch app-toggle {
  flex-basis: 50%;
}
</style>